import { FiltersType, OfferType } from '@/types';

/**
 * Returns the number of "active" filters for badge/chips (PROP-673).
 * Counts: categories, equipment, locations, area, rooms, price/rent, energy.
 */
export const getActiveFiltersCount = (filters: FiltersType): number => {
  const {
    categoriesValue,
    equipmentValue,
    unitListValue,
    areaValue,
    roomNumberValue,
    priceValue,
    rentPriceValue,
    powerConsumptionClasses,
    energyClassFactors,
    locations,
    offerTypeValue,
  } = filters;

  let count = 0;
  count += categoriesValue?.length ?? 0;
  count += equipmentValue?.length ?? 0;
  count += unitListValue?.length ?? 0;
  if (areaValue?.length === 2) count += 1;
  if (roomNumberValue?.length === 2) count += 1;
  if (offerTypeValue === OfferType.SELL && priceValue?.length === 2) count += 1;
  if (offerTypeValue === OfferType.RENT && rentPriceValue?.length === 2) count += 1;
  if (powerConsumptionClasses?.length) count += 1;
  if (energyClassFactors?.length) count += 1;
  count += locations?.length ?? 0;

  return count;
};
